import type { Answers } from "@/schema/quizSchema";
import type { WaterView } from "../view";
import {
  badge, eyebrow1, buildPunch, ctaPage1, nextLine1, advisoryC,
  causesFor, PROFILES, CAUSES_HEADING, type Severity,
} from "../profiles";
import { renderRich } from "./rich";
import { SeverityMeter } from "./SeverityMeter";
import { StatStrip } from "./StatStrip";

export function ResultPage1({
  view, severity, answers, onSeeSolution,
}: {
  view: WaterView;
  severity: Severity;
  answers: Answers;
  onSeeSolution: () => void;
}) {
  const profile = PROFILES[view.profile];
  const legal = profile.legal;
  const causes = legal ? null : causesFor(view.profile, view, answers);
  return (
    <section className={`problem reveal${legal ? "" : " tall"}`}>
      <span className="badge reveal">
        <span className="dot" />
        {badge(view.cp, view.displayName)}
      </span>
      <div className={`v-eyebrow reveal${legal ? " mauve" : ""}`}>{eyebrow1(view.profile)}</div>
      <p className="punch reveal">{renderRich(buildPunch(view.profile, view, severity))}</p>

      {!legal && <SeverityMeter severity={severity} />}

      <StatStrip view={view} />

      {!legal && (
        <div className="bodyimpact reveal">
          <div className="bcell">
            <div className="bt">En tu piel</div>
            <div className="bb">{renderRich(profile.piel ?? "")}</div>
          </div>
          <div className="bcell">
            <div className="bt">En tu pelo</div>
            <div className="bb">{renderRich(profile.pelo ?? "")}</div>
          </div>
        </div>
      )}

      {!legal && causes && (
        <div className="causes reveal">
          <div className="causes-h">{CAUSES_HEADING}</div>
          {causes.map((c, i) => (
            <div className="cause" key={i}>
              <span className="cn">{i + 1}</span>
              <div className="ctext">
                <b>{c.label}</b> — {c.explain}
              </div>
            </div>
          ))}
        </div>
      )}

      {legal && (
        <div className="advisory reveal">
          <p>{renderRich(advisoryC)}</p>
        </div>
      )}

      <button type="button" className="cta reveal" onClick={onSeeSolution}>
        <span>{ctaPage1(view.profile)}</span>
        <span aria-hidden> →</span>
      </button>
      {!legal && <div className="next-line reveal">{nextLine1}</div>}
    </section>
  );
}
